__turbopack_context__.v({
  "tag": "Tags-module__xQxILa__tag",
  "tags": "Tags-module__xQxILa__tags",
});
